
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { message, Collapse, Button, Tabs } from 'antd';
import queryString from 'query-string';
import { RiUserSettingsLine } from 'react-icons/ri';
import { IoIosTimer } from 'react-icons/io';
import { AiOutlineFileSearch, AiOutlineFire } from 'react-icons/ai';
import { GiHumanTarget } from 'react-icons/gi';
import { CampaignGetSingle } from '../../apis/Brand/Campaigns/CampaignGetSingle';
import { useGlobalState } from '../../store/state';
import CampaignBaseDetailsComponent from '../../components/Admin/Campaigns/Details/CampaignBaseDetailsComponent';
import CampaignScheduleComponent from '../../components/Admin/Campaigns/Details/CampaignScheduleComponent';
import CampaignBriefComponent from '../../components/Admin/Campaigns/Details/CampaignBriefComponent';
import CreativeCardsPreview from '../../components/Admin/Campaigns/Details/CreativeCardsPreview';
import CampaignTargetsComponent from '../../components/Admin/Campaigns/Details/CampaignTargetsComponent';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import { GetACampaign } from '../../apis/Admin/Campaigns/GetACampaign';
import { UpdateCampaignStatus } from '../../apis/Admin/Campaigns/UpdateCampaignStatus';
import { CreativeSubmissionsHolder } from '../../components/Admin/Campaigns/Creatives/CreativeSubmissionsHolder';
import { AdminChatHolder } from '../../components/Admin/Campaigns/Chats/AdminChatHolder';
import CampaignPayoutHolder from '../../components/Admin/Campaigns/Payouts/CampaignPayoutHolder';

const { Panel } = Collapse;
const { TabPane } = Tabs;
const AdminCampaignDetailsPage = () => {
  const params = useParams();
  const history = useHistory();
  const [user] = useGlobalState('user');
  const [queryVals, setQueryVals] = useState({
    status: 'review',
    view: 'brief',
  });
  const [camp, setCamp] = useState({});
  const getCampaignDetails = () =>{
    GetACampaign(user.accessToken, params.campaignId).then(({ status, response }) =>{
      console.log('response from view camp==>', response);
      if (status === 200) {
        setCamp(response);
      } else {
        message.error('Error while getting campaign Detatails');
      }
    });
  };
  useEffect(() =>{ // load all list first time
    getCampaignDetails();
    const { status, view } = queryString.parse(window.location.search);
    console.log('view', history);
    setQueryVals({
      status, view,
    });
  }, []);

  const ChangeCampaignStatus = (campStatus) =>{
    UpdateCampaignStatus(user.accessToken, params.campaignId, { campaignstatus: campStatus }).then(({ status, response })=>{
      console.log('status response', response);
      if (status === 200) {
        message.success('Campaign Status Changed to Published!');
        getCampaignDetails(); // refetching campaign details
        // history.push(`/admin/dashboard/campaigns/${params.campaignId}/published`)
        history.push(`/admin/dashboard/campaigns/${params.campaignId}?status=${campStatus}&view=brief`);
      } else {
        message.error('There is some issue to update Campaign Status');
      }
    });
  };

  const tabButtonClick = (val) =>{
    console.log('val uin', val);
    setQueryVals({
      ...queryVals,
      view: val,
    });
  };

  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6">
            <p className="m-0"><strong>Campaign Details</strong></p>
          </div>
          <div className="col-md-6 text-right">
            {
              camp.campaignstatus === 'review' ?
                <>
                  <Button className="common_button py-1"
                    title="Accept this campaign"
                    onClick={() => ChangeCampaignStatus('published')}>Approve</Button>
                  <Button className="common_button outlined py-1 ml-2 danger"
                    title="Reject this campaign"
                    onClick={() => ChangeCampaignStatus('rejected')}>Reject</Button>
                </> :
                null
            }
          </div>
        </div>
      </TopSubHeaderComponent>
      <div className="px-3">
        <Tabs activeKey={queryVals.view || 'brief'}
          defaultActiveKey={'brief'}
          size="small"
          onChange={tabButtonClick}>
          <TabPane tab="View Brief"
            key="brief">
            <div className="campaign_details pt-1">
              <div className="row">
                <div className="col-md-8 pr-2">
                  {
                    Object.keys(camp).length?
                      <Collapse
                        className="acc_campaign mb-2 common_collapse"
                        showArrow={false}
                        defaultActiveKey={[1, 2, 3, 4, 5]}
                      >
                        <Panel showArrow={false}
                          key="1"
                          header={
                            <h3 ><RiUserSettingsLine/> Basic Details</h3>
                          }
                        >
                          <CampaignBaseDetailsComponent
                            name={camp.name}
                            budget={camp.budget}
                            campaignstatus={camp.campaignstatus}
                            campId={camp.id}
                            objective={camp.objective}
                            createdAt={camp.createdAt}
                            creativesCount={camp.deliverables.length || 'n/a'}
                            influencerscount={camp.influencerscount}
                            // posts={camp.posts}
                            paymentstatus={camp.paymentstatus}
                            influencerscount={camp.influencerscount}
                            platform={camp.platform}
                            // earnings={camp.earnings}
                          />
                        </Panel>
                        <Panel showArrow={false}
                          key="2"
                          header={
                            <h3 ><IoIosTimer/> Schedule</h3>
                          }
                        >
                          <CampaignScheduleComponent
                            startdate={camp.startdate}
                            enddate={camp.enddate}
                          />
                        </Panel>
                        <Panel showArrow={false}
                          key="3"
                          header={
                            <h3 ><GiHumanTarget/> Targeted Influencers</h3>
                          }
                        >
                          <CampaignTargetsComponent
                            age={camp.influencersettings.age}
                            gender={camp.influencersettings.gender}
                            influencerlistid={camp.influencersettings.influencerlistid}
                            influencersource={camp.influencersettings.influencersource}
                            language={camp.influencersettings.language}
                            location={camp.influencersettings.location}
                            topics={camp.influencersettings.topics}
                          />
                        </Panel>
                        <Panel showArrow={false}
                          key="4"
                          header={
                            <h3 ><AiOutlineFileSearch/> Brief and extras</h3>
                          }
                        >
                          <CampaignBriefComponent
                            brief={camp.brief}
                            hashtags={camp.hashtags}
                            keywords={camp.keywords}
                            mentions={camp.mentions}
                            guidelines={camp.thingstoavoid}
                            refLinks={camp.referencelink}
                          />
                        </Panel>
                        <Panel showArrow={false}
                          key="5"
                          header={
                            <h3 ><AiOutlineFire/> Creatives</h3>
                          }
                        >
                          <CreativeCardsPreview
                            deliverables={camp.deliverables}
                          />
                        </Panel>
                      </Collapse>:
                      <div>No Campaign Details present</div>
                  }
                </div>
                <div className="col-md-4 pl-2">

                </div>
              </div>
            </div>
          </TabPane>
          <TabPane tab="Influencers &amp; Creatives"
            key="creatives">
            <CreativeSubmissionsHolder/>
          </TabPane>
          <TabPane tab="Messages"
            key="messages">
            <AdminChatHolder/>
          </TabPane>
          <TabPane tab="Payouts"
            key="payouts">
            <CampaignPayoutHolder campStatus={camp.campaignstatus}/>
          </TabPane>
          <TabPane tab="Statistics"
            key="statistics">
            <h2>
                            Stats Data
            </h2>
          </TabPane>
        </Tabs>
      </div>
    </BaseLayoutComponent>
  );
};

export default AdminCampaignDetailsPage;
